export class QueryTerm {
  public searchKey: string;
  public searchValue: any;

  constructor(searchKey, searchValue) {
    this.searchKey = searchKey;
    this.searchValue = searchValue;
  }
}
